// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

let app = null;
let auth = null;
let provider = null;

export async function loadFirebaseAuth() {
  if (auth && provider) return { auth, provider };

  const res = await fetch("/api/public/firebase-config");
  if (!res.ok) throw new Error("❌ Failed to fetch Firebase config");

  const config = await res.json();
  app = initializeApp(config);
  auth = getAuth(app);
  provider = new GoogleAuthProvider();

  return { auth, provider };
}
